import { render, staticRenderFns } from "./TermPolicyIndex.vue?vue&type=template&id=88abfc0e&scoped=true"
import script from "./TermPolicyIndex.vue?vue&type=script&lang=js"
export * from "./TermPolicyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88abfc0e",
  null
  
)

export default component.exports